/** Data feed API endpoints, merged into the platform API client. */
export const feedApiEndpoints: Record<string, string> = {
  feedTokens: "/ext/feed/projects/:pk/tokens/",
  makeFeedToken: "POST:/ext/feed/projects/:pk/tokens/",
  revokeFeedToken: "DELETE:/ext/feed/projects/:pk/tokens/:token/",
};
